
    // 类型定义
    interface DataItem {
        id: string;
        video: string;
        cover: string;
        cover2?: string;
        video2?: string;
        title: {
            text: string;
            sub: string;
        };
    }

    import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, nextTick, computed } from 'vue';
    import { setRem } from '~/utils/mobile';
    import { getBrowser, openInFotorAppByAdjustLink, downloadAppFunc, copyTextIntoClipboard, currentHost } from '~/utils/common';
    // @ts-ignore
    import OpenInBrowser from "@/components/common/OpenInBrowser.vue"

    export default {
        layout: "fotor-default",
        components: {
            OpenInBrowser
        },
        // SEO和分享信息配置
        head() {
            const vm: any = this;
            const shareInfo = vm.shareInfo;
            return {
                title: shareInfo.title,
                meta: [
                    { hid: "description", name: "description", content: shareInfo.description },

                    { hid: "og:title", property: "og:title", content: shareInfo.title },
                    { hid: "og:description", property: "og:description", id: "description", content: shareInfo.description },
                    { hid: "og:image", property: "og:image", content: shareInfo.image },
                    { hid: "og:url", property: "og:url", content: shareInfo.url },

                    { hid: "twitter:title", name: "twitter:title", content: shareInfo.title },
                    { hid: "twitter:description", name: "twitter:description", content: shareInfo.description },
                    { hid: "twitter:image", name: "twitter:image", content: shareInfo.image },
                    { hid: "twitter:card", name: "twitter:card", content: "photo" },
                    { name: "robots", content: "noindex,nofollow" },
                    { name: "googlebot", content: "noindex,nofollow" },
                ],
            };
        },

        setup() {
            const { proxy: vm } = getCurrentInstance()! as any;
            const pageData = reactive(vm.$t("new_home"));
            const { $pageLanguage } = vm;
            // 响应式数据
            const dataList = ref<DataItem[]>([]);

            const currentHost = () => {
                return process.env.NODE_ENV === "development" ? "http://test-nuls-mobile.fotor.com" : "http://nuls-mobile.fotor.com"
            }

            const shareInfo = {
                title: 'Fotor: All-in-one Photo Editor',
                description: 'For easier editing and better design. Join Fotor today!',
                image: currentHost() + '/favicon.png',
                url: currentHost(),
            }
            // 初始化数据列表
            const initDataList = () => {
                dataList.value = [
                    {
                        id: '1',
                        cover: "https://dl.haozhaopian.net/download/index1.webp?",
                        video: "https://dl.haozhaopian.net/download/index1.webm",
                        cover2: "https://dl.haozhaopian.net/download/index1_ios.jpg",
                        video2: "https://dl.haozhaopian.net/download/index1_ios.mp4",
                        title: {
                            text: $pageLanguage === 'en' ? 'AI Photo & Video Creator for ' : pageData.title1,
                            sub: $pageLanguage === 'en' ? 'Everyone' : '',
                        },
                    },
                    {
                        id: "2",
                        cover: "https://dl.haozhaopian.net/download/index2.webp",
                        video: "https://dl.haozhaopian.net/download/index2.webm",
                        cover2: "https://dl.haozhaopian.net/download/index2_ios.jpg",
                        video2: "https://dl.haozhaopian.net/download/index2_ios.mp4",
                        title: {
                            text: $pageLanguage === 'en' ? 'What Our Creators Are ' : pageData.title2,
                            sub: $pageLanguage === 'en' ? 'Saying' : '',
                        }
                    },
                    {
                        id: "3",
                        cover: "https://dl.haozhaopian.net/download/index3.webp",
                        video: "https://dl.haozhaopian.net/download/index3.webm",
                        cover2: "https://dl.haozhaopian.net/download/index3_ios.jpg",
                        video2: "https://dl.haozhaopian.net/download/index3_ios.mp4",
                        title: {
                            text: $pageLanguage === 'en' ? 'Unlock More' : pageData.title3,
                            sub: $pageLanguage === 'en' ? 'Creative Tools' : '',
                        }
                    }
                ];
            };

            // 计算属性：是否为iOS设备 是否为Android设备
            const isIOSDevice = computed(() => getBrowser().isiOS);
            const isAndroidDevice = computed(() => getBrowser().isAndroid);
            const canUseWebP = ref(false)
            // 是否进入页面就自动打开 app store
            const autoOpenAppStore = () => {
                // 参数中有 app_store 则自动触发点击下载按钮
                if (!vm.$route.query.app_store || vm.$refs.refOpenInBrowser.needGuide) {
                    return false;
                }

                // 延迟200ms打开应用商店
                const timerId = setTimeout(() => {
                    downloadApp();
                }, 200);

                // 监听页面可见性变化，如果用户切换回页面则取消打开
                document.addEventListener(
                    "visibilitychange",
                    function cleanup() {
                        document.removeEventListener("visibilitychange", cleanup);
                        clearTimeout(timerId);
                    },
                    { once: true }
                );

                return true;
            }

            const downloadApp = () => {
                //当路径中有 store_link 参数时，使用该参数作为应用商店链接打开
                let store_link = vm.$route.query.store_link;
                if (store_link) {
                    location.href = store_link;
                    return;
                }

                //如果是由桌面网页支付成功后扫码进来的，单独使用一个 adjust 链接
                if (
                    vm.$route.query.utm_source && "utm_source" ||
                    vm.$route.query.utm_content && "upgrade_success_window" ||
                    vm.$route.query.utm_campaign && "web_to_app"
                ) {
                    const schema = "fotor://" + location.search;
                    openInFotorAppByAdjustLink({
                        campaign: "web_to_app",
                        adgroup: "upgrade_success_window",
                        schema: schema,
                    });
                    return;
                }

                // 默认下载行为
                downloadAppFunc(
                    "",
                    false,
                    encodeURIComponent(vm.$route.query.referrer),
                    "fotor"
                );
            }

            const btnDownload = () => {
                if (vm.$refs.refOpenInBrowser.needGuide) {
                    vm.$refs.refOpenInBrowser.showMask();
                    return;
                }
                const furl = vm.$route.query.furl || "";
                if (furl) {
                    copyTextIntoClipboard(furl);
                }
                downloadApp()
            }

            const swiperOptions = reactive({
                direction: 'vertical', // 垂直方向滑动
                slidesPerView: 1, // 改回1，确保一次只显示一个slide
                spaceBetween: 0, // 移除间距
                mousewheel: true,// 鼠标滚轮
                speed: 250,
                watchSlidesProgress: false,// 监听进度
                watchSlidesVisibility: false,// 监听可见性
                initialSlide: 0,
                effect: 'coverflow', // 使用基础slide效果
                scrollbar: false,// 滚动条
                pagination: false,// 分页器
                // 禁用一些可能导致累积高度的特性
                freeMode: false,// 自由模式
                nested: false,// 嵌套
                cssMode: false,
                // 添加一些控制选项
                resistanceRatio: 0, // 禁用抵抗
                allowTouchMove: true,// 允许触摸移动
                shortSwipes: true,// 短滑动
                followFinger: true,// 跟随手指
                threshold: 20,// 阈值
                touchRatio: 1,// 触摸比例
                // 优化触摸体验
                longSwipes: true,
                longSwipesRatio: 0.3, // 降低长滑动的触发阈值
                touchAngle: 45, // 允许更大的滑动角度
                touchMoveStopPropagation: true,
                preventInteractionOnTransition: false, // 允许过渡时交互
            });
            const swiperRef = ref(null);









            // 是否进入页面就自动打开 app store
            onMounted(() => {
                if (process.client) {
                    try {
                        //观察是否支持webp
                        // 初始化数据
                        initDataList();
                        autoOpenAppStore();
                        // 初始化设置
                        setRem(document, window, 375);

                    } catch (error) {
                        console.error('组件初始化失败:', error);
                    }
                }
            });

            // 处理滑动到下一页
            const handleNextSlide = () => {
                const swiper = swiperRef.value as any;
                if (swiper && swiper.$swiper) {
                    swiper.$swiper.slideNext();
                }
            };

            return {
                // 基础配置
                shareInfo,
                swiperOptions,
                swiperRef,

                // 数据
                dataList,
                pageData,

                // 设备和状态
                isIOSDevice,
                isAndroidDevice,
                canUseWebP,

                // 方法
                autoOpenAppStore,
                handleNextSlide,
                downloadApp,
                btnDownload,
            };
        }
    };
